<template>
	<div>
    <ul class="nav">
      <li class="nav-items" v-for="(menus, index) in menu" :key="index">
        <span class="nav-event clear" :class="{'show': menus.show, 'selected': menus.isSeleced}" v-if="menus.children && menus.children.length" @click.stop="showEvent(index, $route.path)">
          <i class="fl icon" :class="menus.icon"></i>
          <span class="fl">{{menus.label}}</span>
          <i class="mark fr"></i>
        </span>
        <a :href="menus.url" class="nav-items-link clear" :class="{'show': menus.show}" v-else-if="/(http|https):\/\/([\w.]+\/?)\S*/.test(menus.url)" >
          <i class="fl icon" :class="menus.icon"></i>
          <span class="fl">{{menus.label}}</span>
        </a>
        <router-link :to="menus.url" class="nav-items-link clear" :class="{'show': menus.show}" v-else >
          <i class="fl icon" :class="menus.icon"></i>
          <span class="fl">{{menus.label}}</span>
        </router-link>
        <ul class="nav-item" v-show="menus.show">
          <li class="nav-item-event" v-for="(menu, i) in menus.children" :key="i">
            <a :href="menu.url" class="nav-link" :class="{'active': menu.show}" v-if="/(http|https):\/\/([\w.]+\/?)\S*/.test(menus.url)">{{menu.label}}</a>
            <router-link :to="menu.url" class="nav-link" :class="{'active': menu.show}" v-else>{{menu.label}}</router-link>
          </li>
        </ul>
      </li>
    </ul>
    
	</div>
</template>

<script>

import cache from '../config/cache'

export default {
  name: 'side-menu',
  data () {
    return {
      menu: cache['menu']
    }
  },
  watch: {
    $route(to,from){
      this.selectEvent(to.path);
    }
  },

  created() {
    this.selectEvent(this.$route.path);
  },
  
  methods: {

    selectEvent (path) {

      let sideMenu = Object.assign([], this.menu);

      let numIndex = '', childrenIndex = '';
      sideMenu.forEach((item, index)=>{
        if (item.url === path) {
            numIndex = index
        }
        item['show'] = false;
        item['isSeleced'] = false;
        if (item.children && item.children.length) {
          item.children.forEach((list, i)=>{
            if (list.url === path) {
              numIndex = index;
              childrenIndex = i;
            }
            list['show'] = false;
          })
        }
      })
      if (numIndex !== '' && childrenIndex === '') {
        sideMenu[numIndex]['show'] = true;
      }
      else if (childrenIndex !== '') {
        sideMenu[numIndex]['show'] = true;
        sideMenu[numIndex]['children'][childrenIndex]['show'] = true;
      }

      this.menu = Object.assign([], sideMenu);
    },

    showEvent(index, path) {

      let sideMenu = Object.assign([], this.menu);

      sideMenu[index]['show'] = !sideMenu[index]['show'];

      if(!sideMenu[index]['show'] && sideMenu[index].children && sideMenu[index].children.length) {
        sideMenu[index].children.forEach((list, i)=>{
          if (list.url === path) {
            sideMenu[index]['isSeleced'] = true;
          }
        })
      }
      else if (sideMenu[index].children && sideMenu[index].children.length){
        sideMenu[index].children.forEach((list, i)=>{
          if (list.url === path) {
            sideMenu[index]['isSeleced'] = false;
          }
        })
      }
      
      this.menu = Object.assign([], sideMenu);
    }
  }
  
}
</script>
<style scoped>
  * {
    padding: 0;
    margin: 0;
  }
  ul,
  li {
    list-style: none;
  }
  .fl {
      float: left;
  }

  .fr {
      float: right;
  }

  .clear {
      clear: both;
  }

  .clear:after {
      content: "";
    display: block;
    clear: both;
  }
  
  .nav-items {
    padding: 10px 0 5px;
    border-bottom: 1px solid #EAEEF4;
    position: relative;
  }
  .nav-items:last-child {
    border-bottom: 0;
  }
  .nav-event {
    display: block;
    font-family: PingFang-SC-Medium;
    font-size: 12px;
    color: #8B8B8B;
    line-height: 17px;
    padding: 9px 0px 10px 17px;
    margin-bottom: 5px;
    cursor: default;
  }
  .nav-event  .icon {
    display: block;
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }
  .nav-event  .mark {
    display: block;
    width: 8px;
    height: 8px;
    margin-right: 10px;
    margin-top: 5px;
    background: url("../assets/img/nav_ic_arrow_down.svg") no-repeat center;
  }
  .nav-event.show .mark {
    background: url("../assets/img/nav_ic_arrow_up.svg") no-repeat center;
  }
    
  .nav-items .selected:before {
    content: '';
    width: 4px;
    height: 8px;
    background: #157FDC;
    display: block;
    position: absolute;
    left: 0;
    top: 23px;
  }
  .nav-items-link {
    display: block;
    font-family: PingFang-SC-Medium;
    font-size: 12px;
    color: #8B8B8B;
    line-height: 17px;
    padding: 9px 0px 10px 13px;
    border-left: 4px solid transparent;
    cursor: default;
    margin-bottom: 5px;
  }
  .nav-items-link  .icon {
    display: block;
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }
  .nav-items-link.show {
    border-left: 4px solid #157FDC;
    background: #E9F0F8;
    font-family: PingFangSC-Regular;
    color: #157FDC;
  }
  .nav-item .nav-item-event {
    margin-bottom: 5px;
  }
  .nav-item .nav-item-event .nav-link {
    display: block;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #8B8B8B;
    padding: 9px 0px 10px 33px;
    border-left: 4px solid transparent;
    cursor: default;
  }
  .nav-item  .nav-item-event .nav-link.active {
    border-left: 4px solid #157FDC;
    background: #E9F0F8;
    font-family: PingFangSC-Regular;
    color: #157FDC;
  }
         
  .home-icon {
    background: url("../assets/img/nav_icon_home.svg") no-repeat center;
  }

</style>